/* LG EXPRESS — Bestsellers reveal */
(function () {
  'use strict';
  const reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.dataset.lgBestInit === '1') return;
    root.dataset.lgBestInit = '1';
    const cards = root.querySelectorAll('[data-lg-best-card]');
    if (!cards.length) return;

    if (!('IntersectionObserver' in window)) {
      cards.forEach((c) => c.setAttribute('data-in', 'true'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const idx = Array.from(cards).indexOf(entry.target);
          entry.target.style.transitionDelay = `${Math.min(idx, 8) * 70}ms`;
          entry.target.setAttribute('data-in', 'true');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -8% 0px' }
    );
    cards.forEach((c) => io.observe(c));
  }

  function boot() {
    document.querySelectorAll('[data-lg-best]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-lg-best]');
    if (root) init(root);
  });
})();
